import { inject } from '@angular/core';
import { CanActivateFn, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { StingrayAuthenticationService } from '../stingray-authentication.service';

export const professionalSubscriptionGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const router = inject(Router);
  const stingrayAuthenticationService = inject(StingrayAuthenticationService);
  if (stingrayAuthenticationService.organization.subscription === 'Professional') {
    return true;
  } else {
    return router.navigate(['home'], { replaceUrl: true });
  }
};
